import styled from "styled-components";

export const StyledPortal = styled.div``;